import React from "react";
import { CheckCircle2, AlertTriangle } from "lucide-react";

/** The build's per-patient total against the total the budget states (re-check corrections and visit gaps). */
export default function PatientTotalCheck({ t, money }) {
    if (!t) return null;
    if (t.budget_usd == null) {
        return <div className="text-xs text-white/50" data-testid="sb-patient-total">Per patient: {money(t.build_usd)} · the budget states no per-patient total.</div>;
    }
    const ok = t.matches;
    const diff = Math.abs(t.difference_usd || 0);
    return (
        <div className={`rounded-xl border p-3 text-xs ${ok ? "border-emerald-400/30 bg-emerald-400/5" : "border-amber-400/40 bg-amber-400/5"}`} data-testid="sb-patient-total">
            <div className={`flex items-center gap-2 text-sm font-medium ${ok ? "text-emerald-200" : "text-amber-200"}`}>
                {ok ? <CheckCircle2 className="w-4 h-4" /> : <AlertTriangle className="w-4 h-4" />}
                <span data-testid="sb-patient-total-status">{ok ? "Per-patient total matches the budget" : "Warning: per-patient total does not match the budget"}</span>
            </div>
            <div className="mt-2 flex flex-wrap gap-x-5 gap-y-1 text-white/70 tabular-nums">
                <span data-testid="sb-patient-total-budget">Budget: {money(t.budget_usd)}</span>
                <span data-testid="sb-patient-total-build">Build: {money(t.build_usd)}</span>
                {!ok && <span className="text-amber-200" data-testid="sb-patient-total-diff">Difference: {t.difference_usd > 0 ? "+" : "−"}{money(diff)}</span>}
                {ok && diff >= 0.005 && <span className="text-white/50" data-testid="sb-patient-total-rounding">Rounding: {money(diff)} (under {money(t.rounding_usd ?? 1)})</span>}
                <span className="text-white/40">{t.basis}</span>
            </div>
            {!ok && <div className="mt-1 text-white/45" data-testid="sb-patient-total-issues-hint">The build is still usable — this gap is also listed under the Discrepancies tab.</div>}
            {t.visit_gaps?.length > 0 && (
                <ul className="mt-2 space-y-0.5 text-white/70" data-testid="sb-patient-total-gaps">
                    {t.visit_gaps.map((g) => <li key={g.budget_label}>· {g.visit} ({g.budget_label}): budget {money(g.budget_usd)}, build {money(g.build_usd)}</li>)}
                </ul>
            )}
            {t.corrections?.length > 0 && (
                <ul className="mt-2 space-y-0.5 text-sky-200/80" data-testid="sb-patient-total-corrections">
                    {t.corrections.map((c, i) => <li key={i}>· corrected {c.visit} · {c.line}: {c.from_usd != null ? `${money(c.from_usd)} → ` : "added "}{money(c.amount_usd)}</li>)}
                </ul>
            )}
            {t.explanation && <div className="mt-2 text-white/50" data-testid="sb-patient-total-explanation">{t.explanation}</div>}
        </div>
    );
}
